
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AccountLedgerDialog extends Serenity.EntityDialog<AccountLedgerRow, any> {
        protected getFormKey() { return AccountLedgerForm.formKey; }
        protected getIdProperty() { return AccountLedgerRow.idProperty; }
        protected getLocalTextPrefix() { return AccountLedgerRow.localTextPrefix; }
        protected getNameProperty() { return AccountLedgerRow.nameProperty; }
        protected getService() { return AccountLedgerService.baseUrl; }
        protected getInsertPermission() { return AccountLedgerRow.insertPermission; }
        protected getUpdatePermission() { return AccountLedgerRow.updatePermission; }
        protected getDeletePermission() { return AccountLedgerRow.deletePermission; }
        protected useViewMode() { return true; }
        //protected isViewMode() { return true; }


        protected form = new AccountLedgerForm(this.idPrefix);
        private loadedState: string;
        constructor() {
            super();
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);

            this.form.AccountGroupId.changeSelect2(e => {
                if (this.form.AccountGroupId.value == "38" || this.form.AccountGroupId.value == "27") {
                    q.showAndSetRequiredField(this.form.AccountNo);
                    q.showAndSetRequiredField(this.form.IFSCCode);
                    q.showAndSetRequiredField(this.form.MICRCode);
                    q.showAndSetRequiredField(this.form.Swift);

                } else {
                    q.hideField(this.form.AccountNo);
                    q.hideField(this.form.IFSCCode);
                    q.hideField(this.form.MICRCode);
                    q.hideField(this.form.Swift);

                }
                var groupnature = "";       //AccountGroupRow.getLookup().itemById[this.form.AccountGroupId.value].Nature;
                AccountGroupService.Retrieve({ EntityId: parseInt(this.form.AccountGroupId.value) }
                    , response => {
                        groupnature = response.Entity.Nature;
                    },
                    { async: false });
                if (groupnature == "Expenses") {
                    q.showField(this.form.DefaultTDSType);
                } else {
                    q.hideField(this.form.DefaultTDSType);
                }
            });

        }
        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.LedgerId.value != null) {
                if (this.form.AccountGroupId.value == "38" || this.form.AccountGroupId.value == "27") {
                    q.showAndSetRequiredField(this.form.AccountNo);
                    q.showAndSetRequiredField(this.form.IFSCCode);
                    q.showAndSetRequiredField(this.form.MICRCode);
                    q.showAndSetRequiredField(this.form.Swift);

                } else {
                    q.hideField(this.form.AccountNo);
                    q.hideField(this.form.IFSCCode);
                    q.hideField(this.form.MICRCode);
                    q.hideField(this.form.Swift);

                }
                var groupnature = "";       //AccountGroupRow.getLookup().itemById[this.form.AccountGroupId.value].Nature;
                AccountGroupService.Retrieve({ EntityId: parseInt(this.form.AccountGroupId.value) }
                    , response => {
                        groupnature = response.Entity.Nature;
                    },
                    { async: false });
                if (groupnature == "Expenses") {
                    q.showField(this.form.DefaultTDSType);
                } else {
                    q.hideField(this.form.DefaultTDSType);
                }
            }
            else {
                
                q.hideField(this.form.AccountNo);
                q.hideField(this.form.IFSCCode);
                q.hideField(this.form.MICRCode);
                q.hideField(this.form.Swift);
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        }


         
         
    }
}